package games.polyclub.website.frontend.store.components

import adminlte.pData
import games.polyclub.frontend.lib.react.simplified.SFC
import games.polyclub.frontend.lib.react.simplified.tags.div
import games.polyclub.frontend.lib.react.simplified.tags.img
import games.polyclub.frontend.lib.react.utils.pData
import react.Props
import react.dom.events.MouseEventHandler
import react.useCallback
import react.useState
import web.dom.Element

external interface ImageSelectionProps : Props {
    var images: List<ImageDetails>
    var selectionIndex: Int?
    var onSelectionChange: ((newIndex: Int, oldIndex: Int) -> Unit)?
}

data class ImageDetails(
    val src: String,
    val alt: String,
    val title: String? = null,
)

val ImageSelection = SFC<ImageSelectionProps> { props ->
    val (currentIndex, setCurrentIndex) = useState(props.selectionIndex ?: 0)
    val changeIndex = useCallback<(Int) -> Unit>(currentIndex, setCurrentIndex) { newIndex ->
        if (newIndex != currentIndex) {
            setCurrentIndex(newIndex)
            props.onSelectionChange?.invoke(newIndex, currentIndex)
        }
    }
    val onThumbClick = useCallback<MouseEventHandler<out Element>>(currentIndex, setCurrentIndex) { ev ->
        ev.preventDefault()
        console.log(ev.currentTarget.pData("img-index"))
        ev.currentTarget.pData("img-index")?.toIntOrNull()?.let(changeIndex)
    }
    val current = props.images[currentIndex]
    div("col-12") {
        img("product-image") {
            alt = current.alt
            src = current.src
        }
    }
    div("col-12 product-image-thumbs") {
        props.images.forEachIndexed { index, imageDetails ->
            div("product-image-thumb${if (index == currentIndex) " active" else ""}") {
                onClick = onThumbClick
                pData("img-index", index)
                img {
                    alt = imageDetails.alt
                    src = imageDetails.src
                }
            }
        }
    }
}
